import { render, staticRenderFns } from "./CollapseCard.vue?vue&type=template&id=8068dbe6&scoped=true&"
import script from "./CollapseCard.vue?vue&type=script&lang=js&"
export * from "./CollapseCard.vue?vue&type=script&lang=js&"
import style0 from "./CollapseCard.vue?vue&type=style&index=0&id=8068dbe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8068dbe6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8068dbe6')) {
      api.createRecord('8068dbe6', component.options)
    } else {
      api.reload('8068dbe6', component.options)
    }
    module.hot.accept("./CollapseCard.vue?vue&type=template&id=8068dbe6&scoped=true&", function () {
      api.rerender('8068dbe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CollapseCard.vue"
export default component.exports